import { COLORS } from './colors';
import { HUD } from './hud';

/**
 * Touch overlay readiness cues (docs/06): the DASH / SUPER buttons show a
 * cooldown sweep while charging and pulse once ready — same colours as the
 * HUD dash bar and SUPER READY bar.
 */
export const TOUCH_CUES = {
  dashColor: HUD.dash.readyColor,
  superColor: COLORS.hudSupershot,
  /** Progress ring just outside the button */
  ringGap: 5,
  ringWidth: 5,
  /** Dark sector over the un-charged part of the button */
  sweepColor: 0x0a0614,
  sweepAlpha: 0.6,
  /** Icon alpha while charging */
  dimIconAlpha: 0.4,
  /** Pre-built sweep frames per full charge (no redraw during fights) */
  sweepSteps: 48,
  /** Ready halo: pulse speed (rad/s), alpha floor and scale swing */
  pulseSpeed: 6,
  pulseMinAlpha: 0.3,
  pulseScale: 0.08,
  haloGap: 9,
  haloWidth: 3,
  /** One-shot pop when a button becomes ready (s, extra scale) */
  readyPopTime: 0.3,
  readyPopScale: 0.18,
} as const;

/**
 * Compact phone shop (polish 1, docs/06): the 1280×720 bay scaled onto a
 * phone turns 12 px text into ~6.5 CSS px, so small viewports get their own
 * tabbed layout. Thresholds in CSS px of the canvas' SHORT side.
 */
export const COMPACT_SHOP = {
  /** Any device below this short side gets the compact shop */
  maxShortSide: 500,
  /** Touch-first devices (coarse pointer) below this one too */
  maxShortSideTouch: 640,
} as const;
